import { isUuid } from './slugs';

/**
 * The only place app links are built. Each helper prefers the friendly handle
 * and falls back to the id, which the destination page redirects to the
 * friendly form. So a partial record (no slug selected) is never a broken link.
 */
export function userPath(p: { id: string; username?: string | null }): string {
  return p.username ? `/u/${p.username}` : `/user/${p.id}`;
}

export function userFollowsPath(
  p: { id: string; username?: string | null },
  tab?: 'followers' | 'following',
): string {
  return `${userPath(p)}/follows${tab ? `?tab=${tab}` : ''}`;
}

export function eventPath(e: { id: string; slug?: string | null }): string {
  return `/event/${e.slug || e.id}`;
}

export function voucherPath(v: { id: string; slug?: string | null }): string {
  return `/voucher/${v.slug || v.id}`;
}

/**
 * Where an old UUID URL should move to, or null to stay put. Only fires when the
 * loaded record is the one the URL asked for, so a stale record left over from a
 * previous URL can never redirect to the wrong page.
 */
export function canonicalRedirect(opts: {
  handle: string | undefined;
  currentId: string | undefined;
  record: { id: string; handle?: string | null } | null | undefined;
  /** '/event/', '/voucher/' or '/u/' */
  prefix: string;
}): string | null {
  const { handle, currentId, record, prefix } = opts;
  if (!isUuid(handle) || !record?.handle || record.id !== currentId) return null;
  return `${prefix}${record.handle}`;
}
